import { createReducer } from '@reduxjs/toolkit'

import { InternalTemplatesActions } from './actions'
import type { TemplatesState } from './types'

const initial: TemplatesState = {
  workspaceId: null,
  own: [],
  shared: [],
  saveError: null,
}

export const templatesReducer = createReducer(initial, (builder) => {
  builder
    .addCase(InternalTemplatesActions.set, (state, { payload }) => ({
      ...state,
      ...payload,
    }))
    .addCase(InternalTemplatesActions.remove, (state, { payload }) => ({
      ...state,
      own: state.own.filter((template) => template.id !== payload),
    }))
    .addCase(InternalTemplatesActions.saveFailed, (state, { payload }) => ({
      ...state,
      saveError: payload,
    }))
    .addCase(InternalTemplatesActions.saveReset, (state) => ({
      ...state,
      saveError: null,
    }))
})
